let toastCallback: ((message: string) => void) | null = null;

export function setMessageToast(message: string): void {
  toastCallback?.(message);
}

export function registerToast(setToast: (message: string) => void): () => void {
  toastCallback = setToast;
  return () => {
    toastCallback = null;
  };
}
